import { authProvider } from "./authProvider";
import {environment} from "./config"
import _axios from "axios";
import qs from "qs";

// Workaround for array URL parameters
const axios = _axios.create({
  paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
})

axios.interceptors.request.use(
  async (config) => {
    if(environment.disableAuth) return config;

    const backendUrl = new URL(environment.backendUrl);
    if(!config.url.includes(backendUrl.hostname))
      return config;

    const accessTokenResponse = await authProvider.getAccessToken();
    config.headers.Authorization = `Bearer ${accessTokenResponse.accessToken}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios
